<template>
    <DashboardContentLayout class="space-y-8" :heading="$t(heading)" :has-period-picker="true" :has-pig-type-picker="true" slim>
        <ActivityTable :selectable-record-type-ids="filteredRecordTypeIds"></ActivityTable>
    </DashboardContentLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import ActivityTable from './ActivityTable.vue';
import { ActivityTableRecordType, Module } from '@/types';
import { store } from '@/plugins/store';

interface Props {
    recordTypeIds: ActivityTableRecordType[];
    heading: string;
}

const props = withDefaults(defineProps<Props>(), {
    recordTypeIds: () => [],
    heading: '',
});

const filteredRecordTypeIds = computed(() => {
    const excludedIds: number[] = [];

    if (!store.getters.hasModuleEnabled(Module.Medicine)) {
        excludedIds.push(ActivityTableRecordType.Treatment);
    }

    return props.recordTypeIds.filter((id) => excludedIds.includes(id) === false);
});
</script>
